import { useMap } from 'react-leaflet';
import { IconButton, Tooltip } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { styled } from '@mui/system';

const StyledControl = styled('div')({
  position: 'absolute',
  left: '10px',
  bottom: '30px',
  zIndex: 1000,
  backgroundColor: 'white',
  borderRadius: '4px',
  boxShadow: '0 1px 5px rgba(0,0,0,0.2)',
  '&:hover': {
    backgroundColor: '#f5f5f5'
  }
});

export const LocateControl = ({ userLocation }: { userLocation: { lat: number; lng: number } | null }) => {
  const map = useMap();

  const handleClick = () => {
    if (userLocation) {
      map.flyTo([userLocation.lat, userLocation.lng], 15, {
        duration: 1,
        easeLinearity: 0.25
      });
    }
  };

  return (
    <StyledControl>
      <Tooltip title="Centrar en mi ubicación" arrow>
        <IconButton 
          onClick={handleClick}
          size="medium"
          disabled={!userLocation}
          sx={{
            color: userLocation ? '#1976d2' : 'rgba(0,0,0,0.26)'
          }}
        >
          <MyLocationIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </StyledControl>
  );
};